/**
 * Created by Darius on 2017.04.02.
 */
import fetch from 'isomorphic-fetch';

const options = {
    credentials: 'same-origin',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
};

const ChatArchiveServices = {
    getChatArchives: (query) => fetch(`/api/chatarchive/?query=${encodeURIComponent(query)}`, options)
};

export default {
    ChatArchiveServices
};